import "/var/lib/jenkins/workspace/event-xsj-260120-vue/node_modules/.pnpm/core-js@3.47.0/node_modules/core-js/modules/es.array.iterator.js";
import "/var/lib/jenkins/workspace/event-xsj-260120-vue/node_modules/.pnpm/core-js@3.47.0/node_modules/core-js/modules/es.promise.js";
import "/var/lib/jenkins/workspace/event-xsj-260120-vue/node_modules/.pnpm/core-js@3.47.0/node_modules/core-js/modules/es.promise.finally.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Vue from "vue";
import App from "./App.vue";
import MobileApp from "./mobile-app.vue";
import { createPinia, PiniaVuePlugin } from "pinia";
import { createHead } from "@unhead/vue";
import { gsap } from "gsap";
import { Observer } from "gsap/Observer";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { initLang, preloadFonts } from "@/lib/utils";
import VConsole from "vconsole";
import "vant/lib/index.css";
import "./style.scss";
import { qs } from "./lib/utils";
import { isMobileDevice } from "@/components/basic/share/utils";
// import vClickOutside from 'v-click-outside';
// 只在开发环境启用，生产环境自动忽略
export const QS = qs();
if (process.env.NODE_ENV !== "production" || QS.console) {
  new VConsole();
}
// 1. 关闭生产环境提示（保持不变）
Vue.config.productionTip = false;
if (process.env.NODE_ENV === "development") {
  Vue.config.devtools = true;
}
const head = createHead();
// Vue.use(vClickOutside);
Vue.use(head);
// Vue.use(Overlay);
// Vue.use(CountDown);
// Vue.use(Popover);
const pinia = createPinia();
Vue.use(PiniaVuePlugin);
gsap.registerPlugin(Observer, ScrollTrigger, ScrollToPlugin);
async function initApp() {
  try {
    await initLang();
    const fontLang = Vue.prototype.$lang;
    if (fontLang === "ko-kr") {
      preloadFonts([{
        family: "main-font",
        src: `url("${(await import(`@/resources/raw-fonts/${fontLang}/HangamePoker.ttf`)).default}") format("truetype")`
      }]);
    } else {
      preloadFonts([{
        family: "main-font",
        src: `url("${(await import(`@/resources/raw-fonts/${fontLang}/SourceHanSerif.otf`)).default}") format("opentype")`
      }]);
    }
    // if (fontLang === 'en-us' || fontLang === 'ko-kr') {
    //   preloadFonts([
    //     {
    //       family: "kr-content-2",
    //       src: `url("${
    //         (await import(`@/resources/raw-fonts/${fontLang}/content_2.otf`)).default
    //       }") format("opentype")`,
    //     },
    //     {
    //       family: "kr-content",
    //       src: `url("${
    //         (await import(`@/resources/raw-fonts/${fontLang}/content.otf`)).default
    //       }") format("opentype")`,
    //     },
    //   ]);
    // } else if (fontLang === 'zh-tw') {
    //   preloadFonts([
    //     {
    //       family: "kr-content-2",
    //       src: `url("${
    //         (await import(`@/resources/fonts/${fontLang}/content_2.woff2`)).default
    //       }") format("woff2")`,
    //     },
    //     {
    //       family: "kr-content",
    //       src: `url("${
    //         (await import(`@/resources/raw-fonts/${fontLang}/content.otf`)).default
    //       }") format("opentype")`,
    //     },
    //   ]);
    // } else {
    //   preloadFonts([
    //     {
    //       family: "kr-content-2",
    //       src: `url("${
    //         (await import(`@/resources/fonts/${fontLang}/content_2.woff2`)).default
    //       }") format("woff2")`,
    //     },
    //     {
    //       family: "kr-content",
    //       src: `url("${
    //         (await import(`@/resources/fonts/${fontLang}/content.woff2`)).default
    //       }") format("woff2")`,
    //     },
    //   ]);
    // }
    new Vue({
      pinia,
      render: h => h(isMobileDevice() ? MobileApp : App)
    }).$mount("#app");
  } catch (error) {
    new Vue({
      pinia,
      render: h => h(isMobileDevice() ? MobileApp : App)
    }).$mount("#app");
  }
}
// 3. 执行异步初始化函数
initApp();